export const modeList = {
  SELECTED_MODE: 'SELECTED_MODE',
  NOTHING_MODE: 'NOTHING_MODE',
  CHENGE_MODE: 'CHENGE_MODE',
  ADD_TEMPLATE_MODE: 'ADD_TEMPLATE_MODE',
}